import Cube from "./components/Cube"

function App() {

  return (
    <Cube />
  )
}

export default App
